export const PERF_TOKEN_AUTH_ENABLED = import.meta.env.VITE_PERF_TOKEN_AUTH === '1';
export const PERF_ACCESS_TOKEN_STORAGE_KEY = 'flashPerfAccessToken';
// Activación en RUNTIME del Bearer-desde-localStorage. El perf flag es build-time y
// queda apagado en el build público; el autologin/handoff (escape IG-webview →
// navegador real para conectar MercadoPago) lo prende seteando esta key cuando
// siembra una sesión válida. El token igual lo valida cyclone, así que no es un
// bypass de auth: solo habilita USAR un token que hubo que obtener legítimamente.
export const HANDOFF_ACTIVE_KEY = 'flashHandoffActive';
// One-shot: el autologin-bootstrap lo setea (sessionStorage) cuando el vendor aterriza
// vía handoff con `?src=` (ej. desde el directorio lex_luthor). Analytics lo lee una
// sola vez para emitir `flash_handoff_landed` y cerrar el funnel marketplace → Flash.
export const HANDOFF_LANDED_SOURCE_KEY = 'flashHandoffLandedSource';

export const getPerfAccessToken = (): string | null => {
  if (typeof window === 'undefined') return null;

  try {
    const token = window.localStorage.getItem(PERF_ACCESS_TOKEN_STORAGE_KEY)?.trim();
    if (!token) return null;
    const handoffActive = window.localStorage.getItem(HANDOFF_ACTIVE_KEY) === '1';
    if (!PERF_TOKEN_AUTH_ENABLED && !handoffActive) return null;
    return token;
  } catch {
    return null;
  }
};

export const hasPerfAccessToken = (): boolean => getPerfAccessToken() !== null;

export const clearPerfAccessToken = (): void => {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.removeItem(PERF_ACCESS_TOKEN_STORAGE_KEY);
    window.localStorage.removeItem(HANDOFF_ACTIVE_KEY);
  } catch {
    // localStorage can be unavailable in restrictive browser modes.
  }
};
